import React from "react";

import "./SignUpVerification.styles.scss";
import { Button } from "components/forms";

export const SignUpVerification: React.FC = () => {
  return (
    <div className="page sign-up-page flex">
      <div className="begin-page__image-wrapper"></div>
      <main className="flex-col-fc-fs begin-page__content sign-up-verification__content">
        <div className="flex-row-fs-fc sign-up-verification__top-row">
          <span className="sign-up-verification__text">We sent an email to</span>
          <span className="sign-up-verification__text--big-bold sign-up-verification__email-row ">
            {`${" batamib.p@gmail.com"}`}
          </span>
        </div>
        <span className="sign-up-verification__text">Check your inbox to activate your account.</span>
        <Button
          title="Resend email"
          variant="square"
          type="submit"
          className="sign-up-verification__button"
          // onClick={() => {}}
        />
        <span className="sign-up-verification__text--small-bold">
          Change the email address associated with your account
        </span>
      </main>
    </div>
  );
};
